import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-violet-500/15',
    borderColor: 'border-violet-500/40',
    textColor: 'text-violet-300',
    emoji: '📘',
    title: 'Contenido para Redes Sociales',
    subtitle: 'El sistema copy-paste para publicar, conectar y vender',
    desc: 'Lo que el 90% de las emprendedoras nunca sistematizó. 100 ideas de contenido organizadas por categoría, hooks que detienen el scroll, fórmulas de publicación listas para armar posts en 5 minutos, contenido emocional que conecta de verdad, posts para vender sin parecer desesperada, estructuras de carruseles probadas y banco de frases copy-paste. Todo pensado para emprendedoras argentinas que venden por Instagram y Facebook.'
  }, {
    id: 2,
    lightColor: 'bg-purple-500/15',
    borderColor: 'border-purple-500/40',
    textColor: 'text-purple-300',
    emoji: '📘',
    title: 'Textos para Vender',
    subtitle: 'Sistema copy-paste de ventas para redes y WhatsApp',
    desc: 'No todos los textos de venta funcionan igual. Copies completos para promociones, lanzamientos y descuentos, textos de urgencia y escasez que activan la decisión de compra, llamados a la acción que mueven a la gente a actuar, respuestas profesionales para las 10 objeciones más comunes, mensajes de seguimiento para recuperar ventas perdidas y scripts de confirmación de pedido y post-venta. Con lenguaje 100% rioplatense y contexto argentino real.'
  }, {
    id: 3,
    lightColor: 'bg-fuchsia-500/15',
    borderColor: 'border-fuchsia-500/40',
    textColor: 'text-fuchsia-300',
    emoji: '📘',
    title: 'Historias que Generan Ventas',
    subtitle: 'Sistema copy-paste de stories para conectar, interactuar y vender',
    desc: 'El tomo más importante del sistema. 100 ideas de historias organizadas, 5 secuencias de venta completas listas para publicar, banco de encuestas y preguntas para máxima interacción, historias emocionales que construyen comunidad fiel, estructuras para mostrar productos de forma irresistible, storytelling que engancha y convierte, y los 10 cierres de venta más efectivos para stories. Porque las stories son donde más se vende hoy.'
  }, {
    id: 4,
    lightColor: 'bg-indigo-500/15',
    borderColor: 'border-indigo-500/40',
    textColor: 'text-indigo-300',
    emoji: '📘',
    title: 'Calendario de Contenido',
    subtitle: 'Sistema de planificación mensual para emprendedoras que publican con estrategia',
    desc: 'Los 4 perfiles de contenido de la emprendedora y la estrategia para cada uno. Calendario mensual completo con ideas por día, contenido para fechas especiales argentinas, contenido estacional para cada época del año, la fórmula exacta de proporción entre contenido de valor y venta, rutinas de producción de contenido en 2 horas semanales, y planificación de campañas completas de principio a fin. Porque publicar sin planificar es improvisar.'
  }, {
    id: 5,
    lightColor: 'bg-violet-600/15',
    borderColor: 'border-violet-600/40',
    textColor: 'text-violet-300',
    emoji: '📘',
    title: 'Canva, Diseño y Publicaciones',
    subtitle: 'Sistema visual para verse profesional sin ser diseñadora',
    desc: 'El tomo que más autoridad le da al sistema. Paletas de colores listas para usar con códigos HEX, combinaciones de tipografías probadas para Canva, estructuras visuales para portadas, carruseles y stories, jerarquía visual que facilita la lectura, el método minimalista que más convierte hoy, y los 10 formatos de diseño probados que generan más alcance y ventas. Sin experiencia en diseño. Solo abrís Canva y ejecutás.'
  }, {
    id: 6,
    lightColor: 'bg-violet-400/20',
    borderColor: 'border-violet-400/50',
    textColor: 'text-violet-300',
    emoji: '⭐',
    title: 'Mentalidad y Organización Emprendedora',
    subtitle: 'Sistema de rutinas, productividad y mentalidad para crecer de verdad',
    desc: 'El tomo que transforma el negocio desde adentro. Sistema de organización diaria con el método de los 3 bloques, rutinas semanales y mensuales que funcionan en piloto automático, técnicas de productividad para emprendedoras que trabajan solas, cómo salir del bloqueo creativo en menos de 10 minutos, cómo vender sin vergüenza y sin sentirte pesada, las creencias que frenan y las que impulsan, y los 10 hábitos de las emprendedoras que crecen de verdad.'
  }];
  return <section className="py-20 bg-zinc-900" data-id="element-322">
      <div className="container mx-auto px-4" data-id="element-323">
        <div className="text-center mb-16" data-id="element-324">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-violet-400/15 text-violet-300 border border-violet-400/30 font-bold mb-6 text-[16px]" data-id="element-325">
            🌸 MEGA PACK EMPRENDEDORA
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-326">
            6 Tomos + 4 Bonus
          </h2>
          <p className="text-zinc-200 font-medium text-[16px]" data-id="element-327">
            Del caos al sistema. De la improvisación a la estrategia. 500+
            páginas — Todo resuelto.
          </p>
          <p className="text-violet-300 font-medium text-sm mt-2" data-id="element-328">
            📚 Un tomo por cada dimensión del sistema
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-329">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-violet-900/40 bg-black/70 overflow-hidden shadow-lg hover:shadow-xl hover:border-violet-700/60 transition-all flex flex-col h-full" data-id="element-330">
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-331">
                <div className="text-2xl" data-id="element-332">{tomo.emoji}</div>
                <div data-id="element-333">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-334">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-335">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-336">
                <p className="font-semibold text-violet-200 mb-3 pb-3 border-b border-violet-900/30" data-id="element-337">
                  {tomo.subtitle}
                </p>
                <p className="text-zinc-200 text-sm leading-relaxed" data-id="element-338">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}